import { loadRoute, pinRoute } from "lib/api/routes";
import { userAgentIsAndroid, userAgentIsIphone } from "lib/mobileDeviceChecks";
import { buildQueryString } from "lib/utils";
import _ from "lodash";
import queryString from "query-string";
import React from "react";
import { FormattedMessage as T, injectIntl } from "react-intl";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { ChooseDeviceStep } from "./ChooseDeviceStep";
import { GarminFlow } from "./flows/GarminFlow";
import { MobileAppFlowContainer } from "./flows/MobileAppFlow";
import { OtherFlow } from "./flows/OtherFlow";
import { WahooFlow } from "./flows/WahooFlow";
import { s2dMessages } from "./intlMessages";
import { S2DMobileView } from "./S2DMobileView";

const Flows = {
  iphone: MobileAppFlowContainer,
  android: MobileAppFlowContainer,
  garmin: GarminFlow,
  wahoo: WahooFlow,
  other: OtherFlow,
};

export class SendToDeviceV2 extends React.PureComponent {
  constructor(props) {
    super(props);
    const query = queryString.parse(props.location.search);
    const { postSignin, selectedDevice } = query;
    const skipChooseDevice = postSignin && selectedDevice;
    this.state = {
      step: skipChooseDevice ? 2 : 1,
      selectedDevice,
    };

    if (postSignin) {
      const filteredQuery = buildQueryString(_.omit(query, "postSignin"));
      const withoutSigninParam = filteredQuery ? `?${filteredQuery}` : "";

      props.history.replace(window.location.pathname + withoutSigninParam + window.location.hash);
    }
  }

  componentDidMount() {
    const { loadRoute, pinRoute, route } = this.props;
    const { trouteId } = this.props.match.params;
    if (!route) {
      loadRoute(trouteId);
    } else {
      pinRoute(route.id, { source: "s2d" });
      this._didPin = true;
    }
  }

  componentDidUpdate() {
    const { route, pinRoute } = this.props;
    if (route && !this._didPin) {
      pinRoute(route.id, { source: "s2d" });
      this._didPin = true;
    }
  }

  onChangeDevice = (selectedDevice) => {
    this.setState({ selectedDevice });
  };

  onConfirmDevice = (deviceOverride) => {
    if (deviceOverride) {
      this.setState({ step: 2, selectedDevice: deviceOverride });
    } else {
      this.setState({ step: 2 });
    }
  };

  onNext = () => {
    this.setState({ step: this.state.step + 1 });
  };

  onPrev = () => {
    this.setState({ step: this.state.step - 1 });
  };

  render() {
    const {
      route,
      match: { params },
      intl,
    } = this.props;
    const { selectedDevice, step } = this.state;
    const trouteId = params?.trouteId;

    // bail out if we're being loaded on a mobile device without the app installed
    if (userAgentIsIphone()) {
      return <S2DMobileView platform="iphone" routeId={trouteId} route={route} />;
    }

    if (userAgentIsAndroid()) {
      return <S2DMobileView platform="android" routeId={trouteId} route={route} />;
    }

    const subtitle = (
      <span>
        <T
          id="s2d.sendingRoute"
          defaultMessage="Sending route: <a>{routeName}</a>"
          values={{
            a: (...c) => <a href={`/routes/${trouteId}`}>{c}</a>,
            routeName: route && route.name,
          }}
        />
      </span>
    );

    // a little bit of a hack, but waaaaaay cleaner than trying to bring in <Helmet />
    route &&
      route.name &&
      (document.title = `${intl.formatMessage(s2dMessages.sending, {
        asset: route.name,
      })} · Ride with GPS`);

    if (step > 1) {
      const Flow = Flows[selectedDevice];
      return (
        <Flow
          selectedDevice={selectedDevice}
          step={step}
          onNext={this.onNext}
          onPrev={this.onPrev}
          route={route}
          routeId={trouteId}
          subtitle={subtitle}
        />
      );
    }

    return (
      <ChooseDeviceStep
        route={route}
        routeId={trouteId}
        subtitle={subtitle}
        selectedDevice={selectedDevice}
        onChangeDevice={this.onChangeDevice}
        onConfirmDevice={this.onConfirmDevice}
      />
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    route: state.routes.get(parseInt(ownProps.match.params.trouteId, 10)),
    loggedIn: state.currentUser.id !== undefined,
  };
};

const mapDispatchToProps = {
  loadRoute,
  pinRoute,
};

export const SendToDeviceV2Container = connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(injectIntl(SendToDeviceV2)));
